export default "__VITE_ASSET__CxVE2BZ2__"